<app-card-layout-content class="generic-error">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <app-feedback-failure-svg-icon></app-feedback-failure-svg-icon>
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1 i18n>Si è verificato un errore</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description>
      <p class="generic-error__description" i18n>
        Chiudi l’applicazione e riprova l’operazione. Se dovessero esserci problemi, contatta l’assistenza.
      </p>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
  <div class="p-d-flex p-flex-column p-ai-center p-mt-auto">
    <span i18n>Hai bisogno di supporto?</span>
    <a class="p-mt-1 p-text-bold" [href]="'tel:' + helplineNumber" i18n>Contatta l’assistenza</a>
  </div>
</app-card-layout-content>
